<template>
    <tr>
        <td class="text-nowrap">
            <div class="d-flex gap-2 align-items-center">
                <div v-if="item.profilePictureUrl">
                    <img :src="avatarImage" alt="Profile Picture" class="profile-avatar shadow-lg me-1" />
                </div>
                <div v-else class="default-avatar shadow-lg me-1">
                    <span class="avatar-letter">{{ avatarLetter }}</span>
                </div>
                <div>
                    <p class="m-0 fw-bold text-left">
                        {{ item.firstName }} {{ item.lastName }}
                    </p>
                    <p class="my-0">
                        {{ item.email }}
                    </p>
                </div>
            </div>
        </td>
        <td>{{ parseDateLong(item.dateUpdated) }}</td>
        <td>
            <template v-if="item.status === 'Approved' && item.isEnabled && item.creditStatus === 'Default'">
                <template v-if="item.hasCreditThisMonth">
                    <MDBBadge class="bg-success text-white px-3" style="font-size: 13px;">Credited</MDBBadge>
                </template>
                <template v-else>
                    <MDBBadge class="bg-danger text-white px-3" style="font-size: 13px;">Not Credited</MDBBadge>
                </template>
            </template>
            <template v-else>
                <template v-if="item.creditStatus === 'Pending'">
                    <MDBBadge class="bg-info text-white px-3" style="font-size: 13px;">Processing</MDBBadge>
                </template>
                <template v-else-if="item.creditStatus === 'Rejected'">
                    <MDBBadge class="bg-danger text-white px-3" style="font-size: 13px;">Rejected</MDBBadge>
                </template>
                <template v-else>
                    <span class="ms-1">-</span>
                </template>
            </template>
        </td>
        <td>
            <template v-if="item.status === 'Approved'">
                <MDBBadge class="bg-success text-white px-3" style="font-size: 13px;">Active</MDBBadge>
            </template>
            <template v-else-if="item.status === 'Pending'">
                <MDBBadge class="bg-warning text-white px-3" style="font-size: 13px;">Pending</MDBBadge>
            </template>
            <template v-else-if="item.status === 'Rejected'">
                <MDBBadge class="bg-danger text-white px-3" style="font-size: 13px;">Rejected</MDBBadge>
            </template>
            <template v-else>
                <MDBBadge class="bg-dark text-white px-3" style="font-size: 13px;">Deactivated</MDBBadge>
            </template>
        </td>
        <td class="text-nowrap text-center position-relative">
            <!-- <MDBTooltip v-model="tootltipModal">
                <template #reference>
                    <button type="button" @click.stop="fetchSubscriptionDetails(item)"
                        class="btn-md border-0 bg-transparent primary-text" data-mdb-ripple-init data-mdb-modal-init
                        data-mdb-target="#viewModal">
                        <i class="fas fa-file-text fa-lg pe-none"></i>
                    </button>
                </template>
                <template #tip> Add Credits to Wallet </template>
            </MDBTooltip> -->
            <MDBDropdown v-model="isOpen">
                <button type="button" @click.stop="emit('toggleDropdown', item.id)"
                    class="btn-md border-0 bg-transparent primary-text">
                    <i class="fas fa-ellipsis-v fa-lg pe-none"></i>
                </button>

                <MDBDropdownMenu :animation="false" class="position-absolute end-0 p-2">
                    <MDBDropdownItem tag="div" href="#" class="fw-bold" style="user-select: none;">Actions
                    </MDBDropdownItem>
                    <MDBDropdownItem tag="div" @click.stop="fetchSubscriptionDetails(item)">View Details
                    </MDBDropdownItem>
                    <MDBDropdownItem tag="div" href="#" @click.stop="deactivateModal = true"
                        :disabled="item.status !== 'Approved'">Deactivate
                    </MDBDropdownItem>
                    <MDBDropdownItem tag="div" href="#" @click.stop="approveModal = true"
                        :disabled="item.status !== 'Pending'">
                        Approve</MDBDropdownItem>
                    <MDBDropdownItem tag="div" href="#" @click.stop="rejectModal = true"
                        :disabled="item.status !== 'Pending'">
                        Reject</MDBDropdownItem>
                </MDBDropdownMenu>
            </MDBDropdown>
        </td>
    </tr>
    <MDBModal id="rejectModal" tabindex="-1" labelledby="rejectModalLabel" v-model="rejectModal" class="ps-0">
        <MDBModalHeader>
            <MDBModalTitle id="rejectModalLabel" class="fw-bold">Reject Early Payout Application</MDBModalTitle>
        </MDBModalHeader>
        <MDBModalBody>Are you sure you want to reject this early payout application? This action cannot be undone.
        </MDBModalBody>
        <MDBModalFooter class="gap-2 py-3">
            <MDBBtn class="fw-bold" @click="rejectModal = false" size="sm"> Close </MDBBtn>
            <MDBBtn class="fw-bold" color="danger" size="sm" :disabled="isUpdating"
                @click="updateSubscriptionStatus(item.id, false, 'Rejected')">
                <template v-if="isUpdating">
                    Processing...
                </template>
                <template v-else>
                    Confirm
                </template>
            </MDBBtn>
        </MDBModalFooter>
    </MDBModal>
    <MDBModal id="approveModal" tabindex="1" labelledby="approveModalLabel" v-model="approveModal" class="ps-0">
        <MDBModalHeader>
            <MDBModalTitle class="fw-bold" id="approveModalLabel">
                Approve Early Payout Application
            </MDBModalTitle>
        </MDBModalHeader>
        <MDBModalBody>
            Are you sure you want to approve this early payout application? This will notify the user that their request
            has
            been accepted.
        </MDBModalBody>
        <MDBModalFooter class="py-3 gap-2">
            <MDBBtn class="fw-bold" size="sm" @click="approveModal = false"> Close </MDBBtn>
            <MDBBtn class="fw-bold" color="primary" size="sm" :disabled="isUpdating"
                @click="updateSubscriptionStatus(item.id, true, 'Approved')">
                <template v-if="isUpdating">
                    Processing...
                </template>
                <template v-else>
                    Confirm
                </template>
            </MDBBtn>
        </MDBModalFooter>
    </MDBModal>
    <MDBModal id="deactivateModal" tabindex="1" labelledby="deactivateModalLabel" v-model="deactivateModal"
        class="ps-0">
        <MDBModalHeader>
            <MDBModalTitle class="fw-bold" id="deactivateModalLabel">
                Deactivate Early Payout
            </MDBModalTitle>
        </MDBModalHeader>
        <MDBModalBody class="text-center">
            <p class="px-4">Are you sure you want to deactivate the <strong>Early Pay Plan</strong> for this user?
            </p>
            This indicates their
            revenue has dropped below the required threshold. The user may apply again once eligible.
        </MDBModalBody>
        <MDBModalFooter class="py-3 gap-2">
            <MDBBtn class="fw-bold" size="sm" @click="deactivateModal = false"> Close </MDBBtn>
            <MDBBtn class="fw-bold" color="danger" size="sm" :disabled="isUpdating"
                @click="updateSubscriptionStatus(item.id, false, 'Deactivated')">
                <template v-if="isUpdating">
                    Processing...
                </template>
                <template v-else>
                    Confirm
                </template>
            </MDBBtn>
        </MDBModalFooter>
    </MDBModal>
    <MDBModal id="viewModal" tabindex="1" labelledby="viewModal" v-model="viewModal" staticBackdrop scrollable
        size="lg">
        <MDBModalHeader class="px-4">
            <div class="d-block">
                <MDBModalTitle id="withdrawModal" class="text-black fw-bold">Early Payout Credit</MDBModalTitle>
                <p class="mb-0">Modify user’s Early Payout subscription details.</p>
            </div>
        </MDBModalHeader>
        <MDBModalBody class="p-4 pt-2">
            <MDBTabs v-model="tabs">
                <MDBTabNav fill tabsClasses="mb-3 sticky-top bg-white">
                    <MDBTabItem tabId="receipt" href="receipt" class="fw-bold">Receipt</MDBTabItem>
                    <MDBTabItem tabId="documents" href="documents" class="fw-bold">Documents</MDBTabItem>
                    <MDBTabItem tabId="history" href="history" class="fw-bold">History Log</MDBTabItem>
                </MDBTabNav>
                <MDBTabContent>
                    <MDBTabPane tabId="receipt">
                        <template v-if="subscriptionDetails.isEnabled">
                            <template v-if="isCredited">
                                <div class="d-flex flex-column justify-content-center align-items-center w-100 my-auto">
                                    <div class="d-flex align-items-center justify-content-center rounded bg-light">
                                        <MDBIcon icon="circle-check" iconStyle="fas" class="text-success fs-4" />
                                    </div>
                                    <div class="text-center mt-3">
                                        <p class="fw-bold text-dark fs-5 mb-1">Early Pay Credit Successfully
                                            Submitted</p>
                                        <p class="text-muted fs-6 mb-0">
                                            The Early Pay credit for this month has been
                                            successfully added to the user’s wallet.
                                        </p>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="border rounded-5 p-4">
                                    <h6>Date Applied</h6>
                                    <h5 class="fw-bold">{{ parseDateLong(item.dateUpdated) }}</h5>
                                    <hr>
                                    <div>
                                        <h6 class="fw-bold" style="font-size: 12px;">Breakdown</h6>
                                        <!-- <div class="d-flex justify-content-between align-items-center">
                                                <h6 class="fs-7">Channel Net Revenue</h6>
                                                <h6 class="fs-7 fw-bold">$--</h6>
                                            </div> -->
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="fs-7">Interest Rate</h6>
                                            <h6 class="fs-7 fw-bold">2.5%</h6>
                                        </div>
                                    </div>
                                    <!-- <hr>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h6 class="fs-7">Total Credit Amount</h6>
                                            <h6 class="fs-7 fw-bold">$--</h6>
                                        </div> -->
                                </div>
                                <div class="d-flex gap-3 w-100 mt-4 mb-5">
                                    <div class="w-75">
                                        <MDBInput v-model="creditAmount" label="Amount to be Credited" type="number" />
                                    </div>
                                    <MDBBtn class="btn btn-primary w-50" @click="sendCredit(item.id)"
                                        :disabled="isSending || !creditAmount">
                                        <template v-if="isSending">
                                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Sending...
                                        </template>
                                        <template v-else>
                                            <MDBIcon iconStyle="fas" icon="paper-plane" class="me-1" />
                                            <span v-if="!isMobile">Send Credits</span>
                                            <span v-else>Send</span>
                                        </template>
                                    </MDBBtn>
                                </div>
                                <div>
                                    <h5 class="fw-bold">Update Credit Status</h5>
                                    <div class="d-flex gap-3 mt-3">
                                        <MDBBtn color="info" @click="updateCreditStatus(item.id, 'Pending')"
                                            :disabled="item.creditStatus === 'Processing' || creditAmount || isChanging"
                                            class="flex-grow-1">
                                            <MDBIcon iconStyle="fas" icon="sync" class="me-1" />
                                            Processing
                                        </MDBBtn>
                                        <MDBBtn color="danger" @click="updateCreditStatus(item.id, 'Rejected')"
                                            :disabled="item.creditStatus === 'Rejected' || creditAmount || isChanging"
                                            class="flex-grow-1">
                                            <MDBIcon iconStyle="fas" icon="times-circle" class="me-1" />
                                            Reject
                                        </MDBBtn>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <h3>
                                <div class="d-flex flex-column justify-content-center align-items-center w-100 my-auto">
                                    <div class="d-flex align-items-center justify-content-center rounded bg-light">
                                        <MDBIcon icon="ban" iconStyle="fas" class="text-danger fs-4" />
                                    </div>
                                    <div class="text-center mt-3">
                                        <p class="fw-bold text-dark fs-5 mb-1">Subscription Deactivated</p>
                                        <p class="text-muted fs-6 mb-0">
                                            The user has deactivated their <strong>Early Pay</strong>
                                            subscription.
                                        </p>
                                    </div>
                                </div>
                            </h3>
                        </template>
                    </MDBTabPane>
                    <MDBTabPane tabId="history">
                        <div v-if="creditHistory.length > 0" class="position-relative">
                            <div v-for="(log, index) in sortedCreditHistory" :key="log.id"
                                class="mb-4 position-relative">
                                <span class="position-absolute translate-middle rounded-circle"
                                    style="width: 12px; height: 12px; top: 15%; left: 2%; background-color: var(--primary);"></span>

                                <div v-if="index !== sortedCreditHistory.length - 1" class="position-absolute"
                                    style="top: 20px; bottom: -22px; width: 2px; background-color: #dee2e6; left: 1.6%;">
                                </div>

                                <div class="ms-4">
                                    <div class="d-flex justify-content-between">
                                        <div class="fw-bold">
                                            {{ userDetail.id !== log.createdByUserId
                                                ? "VVV Admin"
                                                : `${log.createdByFullName}` }}
                                        </div>
                                        <small class="text-muted">
                                            {{ new Date(log.dateCreated).toLocaleString() }}
                                        </small>
                                    </div>
                                    <div>{{ log.remarks }}</div>
                                    <div class="fs-7">{{ log.referenceCode }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-center text-muted">
                            No credit history found.
                        </div>
                    </MDBTabPane>
                    <MDBTabPane tabId="documents" class="d-flex flex-column gap-4">
                        <div>
                            <h6 class="fw-bold">Selfie Verification</h6>
                            <img :src="subscriptionDetails.kycSelfieUrl" alt="Selfie Image">
                        </div>
                        <div>
                            <h6 class="fw-bold">Contract Agreement</h6>
                            <div
                                class="w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-light rounded p-3">
                                <i class="fas fa-file primary-text fs-1 mb-3"></i>
                                <button class="btn btn-primary px-4 py-2"
                                    @click="fetchUserContract(subscriptionDetails.kycContractUrl)"
                                    style="min-width: 150px">
                                    Download PDF
                                </button>
                            </div>
                        </div>
                        <div>
                            <h6 class="fw-bold">Identification Cards</h6>
                            <div class="d-flex flex-wrap gap-3">
                                <img :src="subscriptionDetails.kycIdUrls[0]" alt="Selfie Image">
                                <img :src="subscriptionDetails.kycIdUrls[1]" alt="Selfie Image">
                            </div>
                        </div>
                    </MDBTabPane>
                </MDBTabContent>
            </MDBTabs>
        </MDBModalBody>
    </MDBModal>
</template>

<script setup>
import { parseDateLong } from "@/helpers/parseDate";
import { useUserDetailStore } from "@/store/userDetailStore";
import {
    MDBBadge, MDBBtn,
    MDBDropdown,
    MDBDropdownItem,
    MDBDropdownMenu,
    MDBIcon, MDBInput, MDBModal, MDBModalBody,
    MDBModalFooter,
    MDBModalHeader, MDBModalTitle, MDBTabContent,
    MDBTabItem, MDBTabNav, MDBTabPane, MDBTabs
} from "mdb-vue-ui-kit";
import { storeToRefs } from "pinia";
import { computed, defineEmits, defineProps, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { GetSubscriptionCreditById } from "../../../services/Subscriptions/GetSubscriptionCreditById";
import { PatchCreditStatus } from "../../../services/Subscriptions/PatchCreditStatus";
import { PostCredit } from "../../../services/Subscriptions/PostCredit";
import { PutUpdateSubscription } from "../../../services/Subscriptions/PutUpdateSubscription";

const userDetailStore = useUserDetailStore();
const { userDetail } = storeToRefs(userDetailStore)

const props = defineProps({
    item: Object,
    getUsers: Function,
    openDropdownId: [Number, String, null],
});

const emit = defineEmits(["trigger-success-toast", "trigger-error-toast", "toggleDropdown"]);

const isOpen = computed(() => props.openDropdownId === props.item.id);

const isMobile = ref(window.innerWidth <= 767);
const updateResolution = () => {
    isMobile.value = window.innerWidth <= 767;
};

onMounted(() => {
    window.addEventListener('resize', updateResolution);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateResolution);
});

const viewModal = ref(false);
const approveModal = ref(false);
const rejectModal = ref(false);
const deactivateModal = ref(false);

const isUpdating = ref(false)
const updateSubscriptionStatus = async (id, isEnabled, status) => {
    isUpdating.value = true

    try {
        const formData = new FormData();
        formData.append("IsEnabled", isEnabled);
        formData.append("Status", status);
        formData.append("CreditStatus", 'Default');

        await PutUpdateSubscription(id, formData)
        emit("trigger-success-toast", {
            show: true,
            title: "Early Pay Request",
            message: `Plan has been ${status.toLowerCase()} successfully.`
        });
        props.getUsers();
        approveModal.value = false
        rejectModal.value = false
        deactivateModal.value = false
    } catch (error) {
        console.error(error);
        emit("trigger-error-toast", {
            show: true,
            title: "Error",
            message: `Please try again. Failed to execute request: ${error}`
        });
    } finally {
        isUpdating.value = false;
    }
}

// const tootltipModal = ref(false);
const tabs = ref('receipt')

const avatarLetter = computed(() => {
    return props.item?.firstName?.charAt(0).toUpperCase() || '';
});

const avatarImage = ref(props.item?.profilePictureUrl);
watch(() => props.item?.profilePictureUrl, (newUrl) => {
    avatarImage.value = `${newUrl}&t=${Date.now()}`;
});

const subscriptionDetails = ref({})
const creditHistory = ref([])
const isCredited = ref(false)
const fetchSubscriptionDetails = async (data) => {
    viewModal.value = true
    subscriptionDetails.value = data
    try {
        const response = await GetSubscriptionCreditById(data.id)
        if (response) {

            if (response && response.length > 0) {
                creditHistory.value = response
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth();
                const currentYear = currentDate.getFullYear();

                isCredited.value = response.some((item) => {
                    const creditedDate = new Date(item.dateCreated);
                    return (
                        creditedDate.getMonth() === currentMonth &&
                        creditedDate.getFullYear() === currentYear
                    );
                });
            }
        }
    } catch (error) {
        console.error(error)
        emit("trigger-error-toast", {
            show: true,
            title: "Error",
            message: `Failed to fetch credit details: ${error}`
        });
    }
}

const sortedCreditHistory = computed(() =>
    creditHistory.value
        .slice()
        .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
);

const pdfURL = ref('')
const fetchUserContract = async (url) => {
    try {
        pdfURL.value = url
        downloadContract()
    } catch (error) {
        console.error('Error fetching user information:', error)
        emit("trigger-error-toast", {
            show: true,
            title: "Error",
            message: `Error fetching user contract: ${error}`
        });
    }
}

const downloadContract = () => {
    window.open(pdfURL.value, '_blank')
}

const now = new Date();
const monthYear = `${now.toLocaleString('default', { month: 'long' })} ${now.getFullYear()}`;

const creditAmount = ref(null)
const isSending = ref(false)
const sendCredit = async (id) => {
    isSending.value = true
    try {
        const payload = {
            subscriptionId: id,
            amount: creditAmount.value,
            creditSource: "Youtube Revenue",
            creditStatus: 'Default',
            remarks: `Successfully credited from revenue (${monthYear})`
        }
        const response = await PostCredit(payload)
        if (response) {
            const payload = {
                creditStatus: 'Default'
            }
            await PatchCreditStatus(id, payload);
            emit("trigger-success-toast", {
                show: true,
                title: "Early Payout Credit",
                message: "Credit successfully sent."
            });
            viewModal.value = false
            creditAmount.value = null
            props.getUsers()
        }
    } catch (error) {
        console.error(error)
        emit("trigger-error-toast", {
            show: true,
            title: "Error",
            message: `Failed to send payout credit: ${error}`
        });
    } finally {
        isSending.value = false
    }
}

const isChanging = ref(false)
const updateCreditStatus = async (id, itemStatus) => {
    isChanging.value = true

    try {
        const payload = {
            creditStatus: itemStatus
        }
        await PatchCreditStatus(id, payload);
        props.getUsers();
    } catch (error) {
        console.error("Error updating credit status:", error);
    } finally {
        isChanging.value = false
    }
};
</script>

<style scoped>
.btn-primary {
    background-color: var(--primary);
}

.btn-outline-primary {
    border-color: var(--accent);
    color: var(--accent);
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    /* width: 30px;
    height: 30px;
    display: grid;
    place-content: center; */
    vertical-align: middle;
}

.btn-outline-primary i {
    vertical-align: top;
}

.default-avatar {
    width: 50px;
    height: 50px;
    background-color: var(--primary);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 22px;
    font-weight: bold;
}

.profile-avatar {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    object-fit: cover;
}

.avatar-letter {
    text-transform: uppercase;
}
</style>

<style>
.tooltip-inner {
    font-family: "Poppins", sans-serif !important;
    background-color: var(--primary);
    font-size: 12px;
    padding: 3px 12px;
}

.badge-dot {
    background-color: var(--primary);
}
</style>
